import { render, staticRenderFns } from "./AppBgLightAlert.vue?vue&type=template&id=6354137d&scoped=true&"
import script from "./AppBgLightAlert.vue?vue&type=script&lang=js&"
export * from "./AppBgLightAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6354137d",
  null
  
)

export default component.exports